declare let mxStyleChange: any; // available globally
import {xmlToObj} from '../../diagram-render/helpers/xml-to-obj.util';
import * as _ from 'lodash';

export function textShapeGraphChange(graph, cell, change, helper?) {
  const geometry = cell.geometry;
  const action: any = {};
  let shouldSkip = false;

  action.mxKey = cell.id;
  action.position = {
    x: geometry.x,
    y: geometry.y,
    w: geometry.width,
    h: geometry.height
  };
  action.text = graph.getEditingValue(cell);
  action.number = Number(helper.getCellMetadata(cell, 'number'));
  action.position.rotation = graph.getCellStyle(cell)['rotation'] || 0;

  if (change instanceof mxStyleChange) {
    shouldSkip = true;
    const prev = xmlToObj(change.previous);
    const curr = xmlToObj(change.style);

    if (prev.rotation !== curr.rotation) {
      shouldSkip = false;
      action.position.rotation = Number(curr.rotation) || 0;
    }

    if (Boolean(+prev.locked) !== Boolean(+curr.locked)) {
      shouldSkip = false;
      action.locked = Boolean(+curr.locked);
    }
  }

  return shouldSkip
    ? null
    : {
        data: _.cloneDeep(action),
        action: 'changeText',
        type: 'text',
        mxKey: +cell.id
      };
}
